// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-tab-btn.top[data-v-2370a1c3]{margin-right:0}", ""]);
// Exports
module.exports = exports;
